import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ResponseGetCopnys } from '@models/responses/copny-response';
import { MethodsGeneralService } from '@providers/methods-general/methods-general/methods-general';
import { lastValueFrom } from 'rxjs';
import { ResponseGeneral } from '@models/responses/response-general';
import { ParamsNewUrlPortalWeb } from '@models/entities/copny/copny';

@Injectable({
  providedIn: 'root',
})
export class CopnyService {
  urlAdmin: string;
  private _url: string = '';
  private readonly getCopnyInfo = '/system/loadSubscription';
  private readonly saveUrlPortalWeb = '/updatePortalWebId';

  constructor(
    private http: HttpClient,
    private methodGeneral: MethodsGeneralService
  ) {
    this.urlAdmin = environment.serverAdmin;
  }

  private get url(): string {
    this._url = environment.serverUrl;
    return this._url;
  }

  async getCompanyInfo(params: { pk_employee: string; subscription: string; }): Promise<ResponseGetCopnys> {
    const copny$ = this.http.get<ResponseGetCopnys>(
      `${this.url}${this.getCopnyInfo}?${this.methodGeneral.toQueryString(params)}`
    );

    return await lastValueFrom(copny$);
  }

  async saveNewUrl(params: ParamsNewUrlPortalWeb): Promise<ResponseGeneral> {
    const portal$ = this.http.put<ResponseGeneral>(
      `${this.urlAdmin}${this.saveUrlPortalWeb}`,
      params
    );

    return await lastValueFrom(portal$);
  }
}